<template>
    <div class="project-item-card" v-if="cardArr != null">
        <div class="container">
            <div class="card-title">
                <h2>{{cardArr.project_name}}</h2>
            </div>
            <div class="project-card-desc-main">
                <div class="desc-column-container">
                    <div class="column-left" v-if="cardArr.full_info != undefined && pageSetup != null">
                        <div class="desc-red">
                            <ul>
                                <li v-if="cardArr.full_info.location.name != '' && cardArr.full_info.location.data != ''">
                                    <span>{{pageSetup.words_translation.location}}</span>
                                    <h4>{{cardArr.full_info.location.data}}</h4>
                                </li>
                                <li v-if="cardArr.full_info.init.name != '' && cardArr.full_info.init.data != ''">
                                    <span>{{pageSetup.words_translation.final}}</span>
                                    <h4>{{cardArr.full_info.init.data}}</h4>
                                </li>
                                <li v-if="cardArr.full_info.size.name != '' && cardArr.full_info.size.data != ''">
                                    <span>{{pageSetup.words_translation.size}}</span>
                                    <h4>{{cardArr.full_info.size.data}}</h4>
                                </li>
                                <li v-if="cardArr.full_info.type.name != '' && cardArr.full_info.type.data != ''">
                                    <span>{{pageSetup.words_translation.view}}</span>
                                    <h4>{{cardArr.full_info.type.data.name}}</h4>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="column-right">
                        <div class="project-card-carousel">
                            <swiper :options="swiperOption" ref="projectCardCarousel">
                                <swiper-slide v-for="(slide, index) in cardArr.gallery_cards" :key="index">
                                    <div class="slide-pic" :style="'background-image: url(' + slide + ')'"></div>
                                </swiper-slide>
                            </swiper>
                            <div class="swiper-controls project-card-controls" v-if="cardArr.gallery_cards.length > 1">
                                <div class="project-card-btn-prev slider-btn">
                                    <svgIcon name="left-arrow" class="icon-svg"/>
                                </div>
                                <div class="project-card-btn-next slider-btn">
                                    <svgIcon name="right-arrow" class="icon-svg"/>
                                </div>
                            </div>
                            <div class="swiper-pagination project-card-pagination" v-if="cardArr.gallery_cards.length > 1"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="project-card-second-desc" v-if="cardArr.desc_left_column.length > 0 || cardArr.desc_right_column.length > 0 ">
                <div class="column-container">
                    <div class="col-left">
                        <div class="desc-col" v-html="cardArr.desc_left_column"></div>
                    </div>
                    <div class="col-right">
                        <div class="desc-col" v-html="cardArr.desc_right_column"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // var convert = require('cyrillic-to-latin');
    var cyrillicToTranslit = require("cyrillic-to-translit-js")
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'project-card',
        components: {
            svgIcon,
        },
        data () {
            return {
                cardID: this.$route.params.id,
                pageID: this.$route.params.pageID,
                cardArrDate: null,
                cardArr: null,
                anotherArr: null,
                swiperOption: {
                    speed: 800,
                    loop: true,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    slidesPerView: 1,
                    watchSlidesVisibility: true,
                    lazy: {
                        loadPrevNext: true,
                        loadOnTransitionStart: true
                    },
                    autoplay: {
                        delay: 2500,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.project-card-btn-next',
                        prevEl: '.project-card-btn-prev',
                    },
                    pagination: {
                        el: '.project-card-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                },
            }
        },
        methods: {
        },
        computed: mapGetters({
            // pageSetup: 'loadNewsPage',
            pageSetup: 'loadProjectsPage',
            projectItems: 'loadProjectItems',
        }),
        beforeRouteEnter (to, from, next) {
            console.log(to);
            // store.dispatch('getNewsItems');
            if (to.params.pageID != undefined) {
                 axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/' + to.params.pageID + '?slug=' + to.params.id).then(async (response) => {
                    console.log(response);
                    if (response.data.length != 0) {
                        next(vm => {
                            vm.cardArr = response.data[0].acf;
                            vm.$store.commit('setCustomCrumb', vm.cardArr.project_name);
                            vm.$store.commit('removePageLoaderImg');
                            vm.$parent.$refs.topProgress.done();
                        });
                    } else {
                        next('/404', vm => vm.$parent.$refs.topProgress.fail());
                        //PUSH ON 404 PAGE
                    }
                });
            } else {
                next('/404', vm => vm.$parent.$refs.topProgress.fail());
            }
           
            // if (to.params.pageID == undefined) {
            //     // console.log('lox')
            //     var page_id = 'built';
            //     var count = 1;
            //     var data_arr;
            //     var enabled = true;
            //     var start = function() {
            //         // console.log(count)
            //         axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/' + page_id + '?slug=' + to.params.id).then(async (response) => {
            //             count++;
            //             console.log(response);
            //             if (response.data.length != 0) {
            //                 // var data_arr = response;
            //                 next(vm => {
            //                     vm.cardArr = response.data[0].acf;
            //                     vm.$store.commit('setCustomCrumb', vm.cardArr.project_name);
            //                     vm.$store.commit('removePageLoaderImg');
            //                     vm.$parent.$refs.topProgress.done();
            //                 });
            //             } else {
            //                 if (enabled == true) {
            //                     if (count == 2) {
            //                         page_id = 'construction';
            //                         start();
            //                     } else if (count == 3) {
            //                         page_id = 'international';
            //                         start();
                                    
            //                     } else if (count == 4) {
            //                         page_id = 'promising';
            //                         enabled = false;
            //                         start();
            //                     }
            //                 } else {
            //                     // check for 404
            //                     setTimeout(() => {
            //                         if (count == 5 && response.data.length == 0) {
            //                             // console.log(count, '404');
            //                             // PUSH ON 404 PAGE
            //                             next('/404');
            //                         } 
            //                     }, 300);
            //                 }
            //             }
            //         });
            //         // console.log('init');
            //     }
            //     start();
            // }

        },
        beforeCreate() {
            // this.$store.dispatch('getNewsPageData');
            // this.$store.dispatch('getNewsItems');
        },
        created () {
            document.body.dataset.page = 'project-card';

        },
        mounted () {
            console.log(this.pageSetup)
            // this.getData();
            // this.$store.watch(
            //     (state) => state.actionsItemsFilter,
            //     (newValue) => {
            //         if (newValue) {
            //             this.getData();
            //         }
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/projects/projects-card.scss';
    @import '@/styles/components/projects/respond/projects-card-respond.scss';
    // @import '@/styles/respond/news/news-card-respond.scss';
</style>